import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@plaidev/sour-react';
import type { ReactNode } from 'react';
import type { LocalizedText } from '../config/type.js';
import type { MenuItem } from '../types/menuModel.js';
import type { NaviTarget } from '../url/resolveNaviUrl.js';

type Locale = 'ja' | 'en';

export function AlternateEnvironmentLink({
  link,
  hrefResolver,
  onMenuClick,
  locale,
}: {
  link: { label: LocalizedText; path: NaviTarget };
  hrefResolver: (menu: MenuItem) => string;
  onMenuClick?: (menu: MenuItem, event: React.MouseEvent<HTMLAnchorElement>) => void;
  locale: Locale;
}): ReactNode {
  const menu: MenuItem = { name: 'alternateEnvironment', label: link.label, path: link.path };

  return (
    <div className="mt-4 px-2">
      <hr className="mb-4 border-muted" />
      <Button
        as="a"
        variant="basic"
        size="sm"
        href={hrefResolver(menu)}
        className="w-full gap-2 whitespace-nowrap"
        onClick={(event) => onMenuClick?.(menu, event)}
      >
        {link.label[locale]}
        <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="text-xs" aria-hidden="true" />
      </Button>
    </div>
  );
}
